/**
 * @param obj Any javascript object
 * @returns Clone of bject without any references
 */
export function deepClone(obj) {
    return JSON.parse(JSON.stringify(obj));
}
/**
 * Sum numbers from calculation functions return number or array of numbers
 *
 * @param input An array of numbers or generic objects
 * @param func A function that returns a number
 * @returns Sum of numbers from array or function
 */
export function sum(input, func) {
    return input.reduce((prev, curr) => {
        if (typeof func === "function")
            return prev + func(curr);
        if (typeof curr === "number")
            return prev + curr;
        return 0;
    }, 0);
}
/**
 * Rounds up or down, or to closest integer if floating error diff.
 *
 * @param {number} value Value to round
 * @param {(value: number) => number} roundingFunc Rounding function with number argument and number return
 * @return {number} Rounded value
 */
export function roundWithFloatingErrorCheck(value, roundingFunc) {
    const maxFloatingErrorDiff = 1 / 1000000000;
    const diff = Math.abs(value - Math.round(value));
    if (diff > 0 && diff < maxFloatingErrorDiff) {
        return Math.round(value);
    }
    return roundingFunc(value);
}
